import Select, { components } from 'react-select'

import {
  SystemsSelectBtnProps,
  IPowerPlantSystemSelectAllOption,
} from '../../../domain/downloads.types'
import { EQUIPMENT_TYPE_LABEL } from '../../../domain/enums/downloads.enums'
import { Typography, Wrapper } from '../../components/globals'
import { systemsSelectCustomStyles, groupStyles, groupBadgeStyles } from './downloads.styles'
import { t } from '../../../infrastructure/translation/customTranslation'

const GroupHeading: React.FC = (props: any) => {
  const { data, selectProps } = props

  const handleClick = () => {
    // store in groupOptions the options of the group clicked on
    const groupOptions = data.options.map((option: IPowerPlantSystemSelectAllOption) => option)
    // Store in selectedValues the options already selected before the click on the group
    const valuesAlreadySelected = selectProps.value
      ? selectProps.value.map((option: IPowerPlantSystemSelectAllOption) => option)
      : []
    // create an array of unique options
    const newSelectedOptions = Array.from(new Set(groupOptions.concat(valuesAlreadySelected)))

    selectProps.onChange(newSelectedOptions)
  }

  const systemGroupHeadingTranslate: {
    [key in EQUIPMENT_TYPE_LABEL]: string
  } = {
    [EQUIPMENT_TYPE_LABEL.COMPTEUR]: 'Compteur',
    [EQUIPMENT_TYPE_LABEL.METEO]: 'Météo',
    [EQUIPMENT_TYPE_LABEL.ONDULEUR]: 'Onduleur',
    [EQUIPMENT_TYPE_LABEL.CAPTEUR]: 'Capteur',
    [EQUIPMENT_TYPE_LABEL.HYGROMETER]: t('hygrometer'),
    [EQUIPMENT_TYPE_LABEL.SISENSOR]: t('sisensor'),
    [EQUIPMENT_TYPE_LABEL.TEMPSENSOR]: t('tempsensor'),
    [EQUIPMENT_TYPE_LABEL.PYRANOMETER]: t('pyranometer'),
    [EQUIPMENT_TYPE_LABEL.METER]: t('meter'),
    [EQUIPMENT_TYPE_LABEL.INVERTER]: t('inverter'),
  }

  return (
    <components.GroupHeading {...props}>
      <Wrapper onClick={handleClick} style={groupStyles}>
        <Typography>{systemGroupHeadingTranslate[data.label as EQUIPMENT_TYPE_LABEL]}</Typography>
        {Object.values(EQUIPMENT_TYPE_LABEL).includes(data.label) && (
          <span style={groupBadgeStyles}>{data.options.length}</span>
        )}
      </Wrapper>
    </components.GroupHeading>
  )
}

const SystemsSelectBtn: React.FC<SystemsSelectBtnProps> = ({
  powerPlantSystemsOptions,
  handleSystemsChange,
  selectedPowerPlantSystems,
}) => {
  return (
    <Select
      options={powerPlantSystemsOptions}
      value={selectedPowerPlantSystems}
      components={{ GroupHeading }}
      onChange={handleSystemsChange}
      isMulti
      closeMenuOnSelect={false}
      hideSelectedOptions={false}
      styles={systemsSelectCustomStyles}
      placeholder="Select ..."
    />
  )
}

export default SystemsSelectBtn
